import getCountryCodeFromLocale from 'I18n/utils/getCountryCodeFromLocale';
import getLang from 'I18n/utils/getLang';
import getLangLocale from 'I18n/utils/getLangLocale';
import { DEFAULT_PHONE_NUMBER, PHONE_NUMBERS } from '../constants/phoneNumbers';
import { getQueryParam } from './url';
export const hasAssignableOverride = () => getQueryParam('assignable') === 'true';
export const potentiallyOverridenAssignability = isAssignable => {
  const assignableQueryParam = getQueryParam('assignable');
  if (assignableQueryParam === 'true') return true;else if (assignableQueryParam === 'false') return false;else return isAssignable;
};
export const getSalesPhoneNumber = () => {
  const lang = getLang();
  const locale = getLangLocale();
  if (PHONE_NUMBERS[locale]) {
    const countryCodeFromLocale = getCountryCodeFromLocale();
    const countryCode = typeof countryCodeFromLocale === 'string' ? countryCodeFromLocale.toUpperCase() : null;
    return PHONE_NUMBERS[locale][lang] ? {
      phoneNumber: PHONE_NUMBERS[locale][lang],
      countryCode
    } : {
      phoneNumber: PHONE_NUMBERS[locale].en,
      countryCode
    };
  }
  return {
    phoneNumber: DEFAULT_PHONE_NUMBER,
    countryCode: 'US'
  };
};